import styled from 'styled-components';

export const DealSheetWrapper = styled.section`
  padding-right: 15px;
  margin-right: auto;
  margin-left: auto;
  top: 60px;
  right: 0;
  bottom: 0;
  left: 60px;
  overflow-y: auto;
  position: fixed;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
`;

export const DashboardWrapper = styled.section`
  background-color: white;
  padding-right: 15px;
  margin-right: auto;
  margin-left: auto;
  top: 60px;
  right: 0;
  bottom: 0;
  left: 60px;
  overflow-y: auto;
  position: fixed;
`;
